import { render, staticRenderFns } from "./ReceivedIntegrations.vue?vue&type=template&id=28b1c97b&scoped=true&"
import script from "./ReceivedIntegrations.vue?vue&type=script&lang=ts&"
export * from "./ReceivedIntegrations.vue?vue&type=script&lang=ts&"
import style0 from "./ReceivedIntegrations.vue?vue&type=style&index=0&id=28b1c97b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1c97b",
  null
  
)

export default component.exports